import { useEffect, useState } from 'react';
import diffInHours from 'date-fns/differenceInHours';

import { dateFromISO8601 } from '@app/helpers/date';
import useAuthentication from '@app/hooks/useAuthentication';

import LoginPromptPopupBase from './LoginPromptPopup';
import {
  LOGIN_PROMPT_CLOSE_TIME_KEY,
  LOGIN_PROMPT_HIDE_HOURS,
} from './LoginPromptPopup.constants';

const LoginPromptPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { loading, isAuthenticated } = useAuthentication();

  const onClosePrompt = () => {
    // store closed time on local storage
    localStorage.setItem(LOGIN_PROMPT_CLOSE_TIME_KEY, new Date().toISOString());

    // update visble state
    setIsVisible(false);
  };

  useEffect(() => {
    const lastClosedTimeString = localStorage.getItem(
      LOGIN_PROMPT_CLOSE_TIME_KEY,
    );
    if (lastClosedTimeString) {
      const closeDate = dateFromISO8601(lastClosedTimeString);
      const diffHours = diffInHours(new Date(), closeDate);
      setIsVisible(diffHours >= LOGIN_PROMPT_HIDE_HOURS);
    } else {
      setIsVisible(true);
    }
  }, []);

  if (loading || isAuthenticated || !isVisible) return null;

  return <LoginPromptPopupBase onClose={onClosePrompt} />;
};

export default LoginPromptPopup;
